import { KnowledgeSource } from '@vendasta/embeddings';

export class KnowledgeSourceWithSuggestedFlag extends KnowledgeSource {
  isSuggested?: boolean;
}

export const WebChatWidgetAppType = 'WebChatWidget';
export const AIAssistantAppType = 'AIAssistant';
